import util from './shared/util.js';
import config from '../config.js';
import { playerUrl, playerHeaders, alphaClient } from './shared/playerTransport';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/gameplay/`;

class cdoGameplay {
  bootstrap = (data, callback) => util.putJSON(servicesURL + 'bootstrap', data, callback);
  relationships = (data, callback) => util.putJSON(servicesURL + 'relationships', data, callback);
  allocateProgression = (data, callback) => util.putJSON(servicesURL + 'allocate-progression', data, callback);
  resolveAction = (data, callback, onProgress = () => {}) => {
    const controller = new AbortController();
    let stream, finished = false, sequence = -1;
    const finish = (error, result) => {
      if (finished) return;
      finished = true; stream?.close(); callback(error, result);
    };
    // Match the existing raw-JSON transport. A custom application/json header
    // would add a CORS preflight between the UI and backend ports on every turn.
    fetch(playerUrl(servicesURL + 'resolve-action'), { method: 'POST', ...(alphaClient ? { headers: playerHeaders() } : {}),
      body: JSON.stringify(data), signal: controller.signal }).then(async response => {
      let result;
      try { result = await response.json(); } catch {
        return finish({ status: response.status, code: 'INVALID_ACTION_RESPONSE', message: 'The server response could not be read. Reload the saved game before retrying.' });
      }
      if (!response.ok || result?.error) return finish(result?.error || { status: response.status, message: 'Failed to resolve the action.' });
      if (result.status !== 'accepted') return finish(null, result);
      onProgress({ stage: 'resolving', completed: null, total: null });
      stream = new EventSource(playerUrl(servicesURL + 'action-events/' + encodeURIComponent(result.jobToken)));
      const receive = event => {
        let value;
        try { value = JSON.parse(event.data); } catch {
          finish({ status: 502, code: 'INVALID_ACTION_RESPONSE', message: 'Action delivery was interrupted. Reload the saved game before retrying.' });
          return;
        }
        if (value.sequence <= sequence) return;
        sequence = value.sequence;
        if (value.type === 'completed') finish(null, value.result);
        else if (value.type === 'failed') finish(value.error);
        else onProgress(value.progress);
      };
      for (const type of ['progress', 'completed', 'failed']) stream.addEventListener(type, receive);
      stream.onopen = () => onProgress({ connectionIssue: false });
      stream.onerror = () => {
        if (stream.readyState === 2) finish({ status: 410, code: 'ACTION_EXPIRED', message: 'Action delivery was interrupted. Reload the saved game before retrying.' });
        else onProgress({ connectionIssue: true });
      };
    }).catch(error => finish({ status: 0, message: error.message || 'Cannot communicate with service.' }));
    return { abort: () => { finished = true; controller.abort(); stream?.close(); } };
  };
  resolveCommerce = (data, callback) => {
    util.putJSON(servicesURL + 'resolve-commerce', data, callback);
  };
  prepareTurn = (data, callback) => {
    util.putJSON(servicesURL + 'prepare-turn', data, callback);
  };
  turnProgress = (data, callback) => {
    const request = util.putJSON(servicesURL + 'turn-progress', data, callback);
    request.timeout = 8000;
    request.ontimeout = () => callback({ message: 'Progress connection timed out.' });
    return request;
  };
  encounterDiagnostics = (data, callback) => {
    util.putJSON(servicesURL + 'encounter-diagnostics', data, callback);
  };
  placeKnowledge = (data, callback) => {
    util.putJSON(servicesURL + 'place-knowledge', data, callback);
  }
  prepareExecution = (data, callback) => {
    util.putJSON(servicesURL + 'prepare-execution', data, callback);
  };

  prepareActivity = (data, callback) => {
    util.putJSON(servicesURL + 'prepare-activity', data, callback);
  }

  finalizeTurn = (data, callback) => {
    util.putJSON(servicesURL + 'finalize-turn', data, callback);
  }

  context = (data, callback) => {
    util.putJSON(servicesURL + 'context', data, callback);
  }

  routineState = (data, callback) => {
    util.putJSON(servicesURL + 'routine-state', data, callback);
  }

  routineInterruptions = (data, callback) => {
    util.putJSON(servicesURL + 'routine-interruptions', data, callback);
  }

  moveTo = (data, callback) => {
    util.putJSON(servicesURL + 'move-to', data, callback);
  }

  fastTravel = (data, callback) => {
    util.putJSON(servicesURL + 'fast-travel', data, callback);
  }

  resolveCombatRound = (data, callback) => {
    util.putJSON(servicesURL + 'resolve-combat-round', data, callback);
  }

  resolveSpellAcquisition = (data, callback) => {
    util.putJSON(servicesURL + 'resolve-spell-acquisition', data, callback);
  }

  settleTrade = (data, callback) => {
    util.putJSON(servicesURL + 'settle-trade', data, callback);
  }

  settleContract = (data, callback) => {
    util.putJSON(servicesURL + 'settle-contract', data, callback);
  }

  saveSession = (data, callback) => {
    util.putJSON(servicesURL + 'session', data, callback);
  }

  resetSession = (data, callback) => {
    util.putJSON(servicesURL + 'session/reset', data, callback);
  }

  // THIS IS OLD OBSOLETE CODE, ONLY USE FOR REFERENCE IN PLAY2.JS REBUILD  *** DO NOT CALL DIRECTLY.
  start = (data, callback) => {
    util.putJSON(servicesURL + 'start', data, callback);
  }

  // THIS IS OLD OBSOLETE CODE, ONLY USE FOR REFERENCE IN PLAY2.JS REBUILD  *** DO NOT CALL DIRECTLY.
  submit = (data, callback) => {
    util.putJSON(servicesURL + 'submit', data, callback);
  }

  // THIS IS OLD OBSOLETE CODE, ONLY USE FOR REFERENCE IN PLAY2.JS REBUILD  *** DO NOT CALL DIRECTLY.
  reset = (data, callback) => {
    util.putJSON(servicesURL + 'reset', data, callback);
  }
}

const cdo = new cdoGameplay();
export default cdo;
